import { Flex, FormControl, FormErrorMessage } from '@chakra-ui/react';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { formatDate, parseDate } from '../../utils/dateUtils';
import { DatePicker } from '../DatePicker';
import { FormInput } from './FormInput';
import { FormLabel } from './FormLabel';

export const FormDatePicker = ({
    fieldName,
    label,
    labelWidth,
    isRequired = false,
    isReadOnly,
    maxDate,
    minDate,
}: {
    fieldName: string;
    label?: string;
    labelWidth?: string;
    isRequired?: boolean;
    isReadOnly?: boolean;
    maxDate?: Date;
    minDate?: Date;
}) => {
    const {
        formState: { errors, defaultValues },
        setValue,
    } = useFormContext();

    useEffect(() => {
        if (isReadOnly) {
            const value = defaultValues?.[fieldName];
            if (value) {
                setValue(fieldName, formatDate(parseDate(value)));
            }
        }
    }, [defaultValues, fieldName, isReadOnly, setValue]);

    if (isReadOnly) {
        return (
            <FormInput
                fieldName={fieldName}
                label={label}
                labelWidth={labelWidth}
                isRequired={isRequired}
                size="sm"
                isReadOnly
            />
        );
    }

    return (
        <FormControl isInvalid={!!errors[fieldName]} isRequired={isRequired}>
            <Flex align="center">
                {label && <FormLabel fieldName={fieldName} labelWidth={labelWidth} label={label} />}
                <Controller
                    render={({ field: { onChange, value } }) => (
                        <DatePicker onChange={onChange} value={value} maxDate={maxDate} minDate={minDate} />
                    )}
                    name={fieldName}
                />
            </Flex>
            {errors[fieldName] && <FormErrorMessage>{String(errors[fieldName]?.message)}</FormErrorMessage>}
        </FormControl>
    );
};
